module.exports = __webpack_public_path__ + "static/kova-tax-square-logo-b2a72123408d043a4572f798c67be5ce.png";